import { authUser } from "@origin-digital/event-dispatcher";

import { config } from "src/config";

export const isAuthenticated = async () => {
  const authInfo = await authUser({
    auth0Environment: config.env as EnvironmentNames,
  });
  return authInfo ? authInfo.isAuth : false;
};
